import { styled } from "@mui/material";
import Report from "./component";

export default styled(Report)(({ theme }) => ({
  ".download-button": {
    height: 45,
  },
  ".table-view-header": {
    display: "flex",
    justifyContent: "space-between",
    padding: theme.spacing(1),
  },
  ".table-view-heading": {
    padding: theme.spacing(1),
  },
  ".table-view-filter-cont": {
    display: "flex",
    gap: 10,
  },
  ".report-filter": {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing(1),
    marginBottom: "1rem",
    ".MuiFormControl-root": {
      width: "100%",
      maxWidth: "20rem",
      marginRight: "1rem",
    },
    ".search-button": {
      width: 200,
      height: 50,
    },
  },
  ".report-period-cont": {
    display: "inline",
    ".report-period": {
      width: "90%",
    },
    ".report-period-calender": {
      cursor: "pointer",
    },
  },
}));
